import header_logo from '../assets/header_logo.svg';
import hero_img_1 from '../assets/hero_img_1.svg';
import hero_img_2 from '../assets/hero_img_2.svg';
import hero_img_3 from '../assets/hero_img_3.svg';
import channel_img from '../assets/channel_img.png';
import hero_mid from '../assets/hero_mid.svg';
import hero_mid_2 from '../assets/hero_mid_2.svg';
import hero_mid_3 from '../assets/hero_mid_3.svg';
import hero_mid_4 from '../assets/hero_mid_4.svg';

export default {
  header_logo,
  hero_img_1,
  hero_img_2,
  hero_img_3,
  channel_img,
  hero_mid,
  hero_mid_2,
  hero_mid_3,
  hero_mid_4,
};
